import { render, staticRenderFns } from "./ClubRating.vue?vue&type=template&id=385a866d&scoped=true&"
import script from "./ClubRating.vue?vue&type=script&lang=js&"
export * from "./ClubRating.vue?vue&type=script&lang=js&"
import style0 from "./ClubRating.vue?vue&type=style&index=0&id=385a866d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a866d",
  null
  
)

export default component.exports